import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  useTheme,
  styled,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import closeIconSrc from "../../assets/ic_alert_close.svg";

interface PMRemarkDialogProps {
  open: boolean;
  onClose: () => void;
  remarkText: string | null;
}

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    maxWidth: "400px", // Set maximum width
    width: "90%", // Take 90% of the available width up to maxWidth
    margin: "16px",
    borderRadius: "10px",
  },
}));

const PMRemarkDialog: React.FC<PMRemarkDialogProps> = ({
  open,
  onClose,
  remarkText,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <StyledDialog open={open} onClose={onClose}>
      <DialogTitle sx={{ m: 0, p: 2, color: theme.palette.secondary.light }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "text.secondary",
          }}
        >
          <img
            src={closeIconSrc}
            alt={`close-icon`}
            width="16px"
            height="16px"
          />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            minHeight: 100,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            pb: "12px",
          }}
        >
          <Typography
            fontFamily={"Nunito Sans Regular500"}
            sx={{
              textAlign: "center",
              justifyContent: "center",
              maxWidth: "320px", // Constrain text width
            }}
          >
            {remarkText
              ? remarkText
              : t("taskOverViewScreen.noRemarksAvailable")}
          </Typography>
        </Box>
      </DialogContent>
    </StyledDialog>
  );
};

export default PMRemarkDialog;
